export default function CtaBanner() {
  return (
    <section className="relative py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_0c530b8da7269ae740bf9a10ba326e01_eeaa3aa9.jpg"
          alt="Asistencia en carretera GERPAT"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          ¿NECESITA ASISTENCIA INMEDIATA?
        </h2>
        <p className="text-gray-200 text-lg mb-10">
          Respuesta rápida garantizada en las provincias de Lleida y Huesca.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:+34638250936"
            className="flex items-center justify-center gap-3 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            <i className="ri-phone-fill text-xl"></i>
            LLAMAR AHORA
          </a>
          <a
            href="https://wa.me/34974000000"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer text-lg"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
